module.exports = __webpack_public_path__ + "img/plus.11736e28.svg";